function getOneLevelPage(state) {
    const { domainList } = state;
    let arr = [];
    domainList.forEach((item) => {
        arr.push({
            type: 'block',
            component: 'TabNav',
            transform() {
                if (item.tabs.length === 0)
                    return false;
                return {
                    title: item.title,
                    tabs: item.tabs,
                };
            },
        });
    });
    return arr;
}
;
function getHomeConfig(state) {
    const Home = [
        {
            // banner
            type: 'banner',
            component: 'Banner',
            props: {
                // 组件的 props
                wrapperStyle: { background: '#000' },
                style: { margin: '0 auto' },
                className: 'home-top-banner',
            },
            transform(state) {
                // 传入state
                // 用于处理后端数据返回与组件不一致问题，返回一个 props ，与 原来的 props merge
                const { topBanner } = state;
                return {
                    title: topBanner.title,
                    background: topBanner.background,
                };
            },
        },
        ...getOneLevelPage(state),
        {
            // banner
            type: 'banner',
            component: 'Banner',
            props: {
                className: 'home-middle-banner',
                wrapperStyle: { background: '#1C222D' },
                style: {
                    height: 540,
                    width: 1200,
                    margin: '0 auto',
                    backgroundSize: 'contain',
                },
                playScale: 0.1,
            },
            transform(state) {
                const { middleBanner } = state;
                return {
                    title: middleBanner.title,
                    background: middleBanner.background,
                };
            },
        },
        {
            type: 'list',
            component: 'Partner',
            transform(state) {
                const { partner } = state;
                return {
                    source: partner.source,
                    title: partner.title,
                };
            },
        },
    ];
    return Home;
}
;
export default getHomeConfig;
